module.exports = __webpack_public_path__ + "static/media/ic_small_arrow_left.376ed675.svg";